<template>
	<div class="data-table ">
		<!-- <p class="w-100" style="margin: 1.25rem 0;"><b>ORE DI LAVORO</b></p> -->

		<table class="table-totals-day">
			<thead>
				<tr>
					<th>Data</th>
					<th>Ore lavorate</th>
					<th>Ore straordinarie/festive</th>
					<th>Ore viaggio</th>
					<th>Diaria</th>
					<th>Notte</th>
					<th>Km</th>
				</tr>
			</thead>
			<tbody>
				<tr 
					:key="$index"
					v-if="checkVisibilityDay(work)"
					v-for="(work,$index) in revision.workedDetails.days">
					<td>{{ work.day | moment('DD/MM/YYYY') }}</td>
					<td>{{ work.workedHours || ""}}</td>
					<td>{{ work.holidayWorkedHours || ""}}</td>
					<td>{{ work.tripHours || ""}}</td>
					<td>{{ work.diem || ""}}</td>
					<td>{{ work.overNight || ""}}</td>
					<td>{{ work.totalKmTrip || ""}}</td>
				</tr>
				<tr class="empty-row" v-if="revision.workedDetails.days.length < 3">
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				<tr class="row-summary row-summary-total untis">
					<td>Totali</td>
					<td>{{ calculateTotalOfWorkedDeatailsUnit('workedHours') }}</td>

					<td>{{ calculateTotalOfWorkedDeatailsUnit('holidayWorkedHours') }}</td>

					<td>{{ calculateTotalOfWorkedDeatailsUnit('tripHours') }}</td>

					<td>{{ calculateTotalOfWorkedDeatailsUnit('diem') }}</td>

					<td>{{ calculateTotalOfWorkedDeatailsUnit('overNight') }}</td>

					<td>{{ calculateTotalOfWorkedDeatailsUnit('totalKmTrip') }}</td>
					
				</tr>
				<tr class="row-summary row-summary-single-amount" v-if="revision.phase === 'final'">
					<td>Costo unitario</td>
					<td>{{ revision.workedDetails.detailsSingleAmount.workedHours | currencyFilter }}</td>
					<td>{{ revision.workedDetails.detailsSingleAmount.holidayWorkedHours | currencyFilter }}</td>
					<td>{{ revision.workedDetails.detailsSingleAmount.tripHours | currencyFilter }}</td>
					<td>{{ revision.workedDetails.detailsSingleAmount.diem | currencyFilter }}</td>
					<td>{{ revision.workedDetails.detailsSingleAmount.overNight | currencyFilter }}</td>
					<td>{{ revision.workedDetails.detailsSingleAmount.totalKmTrip | currencyFilter }}</td>
				</tr>
				<tr class="row-summary row-summary-totals" v-if="revision.phase === 'final'">
					<td>TOTALI (€)</td>
					<td>{{ calculateTotalOfWorkedDeatails('workedHours') | currencyFilter }}€</td>

					<td>{{ calculateTotalOfWorkedDeatails('holidayWorkedHours') | currencyFilter }}€</td>

					<td>{{ calculateTotalOfWorkedDeatails('tripHours') | currencyFilter }}€</td>

					<td>{{ calculateTotalOfWorkedDeatails('diem') | currencyFilter }}€</td>

					<td>{{ calculateTotalOfWorkedDeatails('overNight') | currencyFilter }}€</td>

					<td>{{ calculateTotalOfWorkedDeatails('totalKmTrip') | currencyFilter }}€</td>
					
				</tr>
			</tbody>
		</table>


		<div class="w-100 margin-print"
			v-if="areAdditionalDetailsVisible()"
			>
			<div>
				<div class="prod-row additional-prod-row"
					v-for="(addictional,$index) in additionalLinesToPrint"
					:key="$index">
						<p class="full-width">{{ addictional.label }}</p>
						<p><b>{{ addictional.amount | currencyFilter }} €</b></p>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss">
	.empty-row{
		td:after{
			content: "-";
			opacity: 0;
			display: block;
		}
	}

	.prod-row{
		border-top: 1px solid #999;
	}
	.table-totals-day{
		th{
			text-transform: uppercase;
			font-size: 0.8rem;
			letter-spacing: 0.15em;
			color: #000;
			padding-top: 0.625rem;
			font-weight: normal;
			font-weight: bold;
			padding-bottom: 0.25rem;
		}

		tr{
			border: 1px solid #dfdfdf;
			border-width: 1px 0px;
			&:nth-child(2n){
				background:#dfdfdf;
			}
		}

		th:first-child,
		td:first-child{
			padding-left: 10px;
		}
		th:last-child,
		td:last-child{
			padding-right: 10px;
		}

		td{
			padding: 0.5rem 0;
			font-weight: normal;
			color: #000;
		}

		th +th,
		td + td{
			text-align: right;
		}
		.row-summary{
			td:first-child{
				font-weight: bold;
			}
			&.row-summary-single-amount{
				border-top: 1px solid #aaa;
			}
			&.row-summary-total,&.row-summary-totals{
				border-top: 2px solid #999;
				&.untis{
					border-top-color:  #999;
				}
				td{
					// font-weight: bold;
				}
			}
			&.row-summary-totals{
				td{
					font-weight: bold;
				}
			}
		}
	}
</style>
<script>
	export default{
		name: 'print-worked-details',
		props: {
			revision: Object,
		},
		computed: {
			additionalLinesToPrint() {
				if (this.areAdditionalDetailsVisible()){
					return this.revision.workedDetails.additionalLines.filter( aLine =>  aLine.amount ||  aLine.label );
				}
				return []
			}

		},
		methods:{
			areAdditionalDetailsVisible() {
				return this.revision.phase === 'final' &&
					this.revision.workedDetails.additionalLines &&
					this.revision.workedDetails.additionalLines.length &&
					this.revision.workedDetails.additionalLines.filter(line => line.label || line.amount).length
			},
			calculateTotalOfWorkedDeatailsUnit(key) {
				let sum = 0;
				this.revision.workedDetails.days.forEach(day => {
					sum = day[key] ? sum + parseFloat(day[key]) : sum;
				})
				const total = sum;
				return isNaN(total) ? 0 : total;

			},
			calculateTotalOfWorkedDeatails(key) {
				let sum = 0;
				this.revision.workedDetails.days.forEach(day => {
					sum = day[key] ? sum + parseFloat(day[key]) : sum;
				})
				const total = parseFloat(this.revision.workedDetails.detailsSingleAmount[key]) * sum;
				return isNaN(total) ? 0 : total;
			},
			checkVisibilityDay(work) {
				if (work.day){
					return true
				}
				return work.workedHours ||
					work.holidayWorkedHours ||
					work.tripHours ||
					work.diem ||
					work.overNight ||
					work.totalKmTrip ;
			}
		}
	}
</script>